function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Quarantine");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Quarantine"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle",
  fill: "#FFFFFF",
  opacity: 0,
  points: "0 0 28 0 28 28 24.3851332 28 0 28"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.6639648,0.266280221 L26.67212,10.9289474 C27.0850948,11.2956493 27.1226064,11.9277021 26.7559046,12.3406769 C26.5661277,12.5544011 26.2939679,12.6767045 26.0081476,12.6767045 L24.424,12.676 L24.4246857,27 C24.4246857,27.5522847 23.9769705,28 23.4246857,28 L3.95205714,28 C3.3997724,28 2.95205714,27.5522847 2.95205714,27 L2.952,12.676 L1.99183714,12.6767045 C1.43955239,12.6767045 0.991837138,12.2289892 0.991837138,11.6767045 C0.991837138,11.3908841 1.11414051,11.1187243 1.32786468,10.9289474 L13.3360199,0.266280221 C13.7147835,-0.0700437407 14.2852012,-0.0700437407 14.6639648,0.266280221 Z M16.4400638,12.6767045 L11.5599209,12.6767045 L11.5598209,16.1767045 L8.14382091,16.1767045 L8.14382091,21.1767045 L11.5598209,21.1767045 L11.5599209,24.6767045 L16.4400638,24.6767045 L16.4398209,21.1767045 L19.8561638,21.1767045 L19.8561638,16.1767045 L16.4398209,16.1767045 L16.4400638,12.6767045 Z",
  id: "Combined-Shape",
  fill: "#3366CC"
})));

var SvgQuarantine = function SvgQuarantine(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "29px",
    viewBox: "0 0 28 29",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuarantine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/quarantine.9b9f7fd0.svg";
export { ForwardRef as ReactComponent };